import Vue from 'vue'
const bus = new Vue()
// 页面信息
bus.pageInfo = {}
// 平台默认值
bus.pageInfo.platform = ''
bus.pageInfo.isFirst = true //page是account,并且第一次进入
bus.pageInfo.gameIdKey = '' //app
bus.pageInfo.accountIdKey = '' //account

// 错误信息
bus.errCode = 0
export default bus